import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "ImportCompanyIFrame": () => import("./components/tiles/ImportCompanyIFrame.vue"),
    "ImportCompanyV2IFrame": () => import("./components/tiles/ImportCompanyV2IFrame.vue"),
    "ActivationFormIFrame": () => import("./components/tiles/ActivationFormIFrame.vue"),
    "HelpColdirettiIFrame": () => import("./components/tiles/HelpColdirettiIFrame.vue"),
    "SystemMonitoringIFrame": () => import("./components/tiles/SystemMonitoringIframe.vue"),
    "QdcIframe": () => import("./components/tiles/QdcIframe.vue"),

    "ImportCompanyTileContainer": () => import("./components/ImportCompanyTileContainer.vue"),
    "ImportCompanyV2TileContainer": () => import("./components/ImportCompanyV2TileContainer.vue"),
    "ActivationFormTileContainer": () => import("./components/ActivationFormTileContainer.vue"),
    "HelpColdirettiTileContainer": () => import("./components/HelpColdirettiTileContainer.vue"),
};

export default globals;
